<template>
    <div>
        <breadcrumb
            class="px-4 bg-light pb-0 breadcrumb-scope"
            :items="breadcrumbs"
        />
        <div class="page-content">
            <HeroSection />
            <MarketingSpacer height="86px" />
            <h2 class="wp-block-heading has-text-align-center">
                Boost Efficiency and Increase<br />Client Satisfaction With
                PetCare
            </h2>
            <MarketingSpacer height="86px" />
            <div v-for="(item, index) in mediaItems" :key="index">
                <MediaText
                    class="media-text"
                    :image="item.image"
                    :title="item.title"
                    :content="item.content"
                    :reverse="item.reverse"
                />
                <MarketingSpacer height="62px" />
            </div>
            <MarketingSpacer height="123px" />
        </div>
    </div>
</template>

<script>
import Breadcrumb from "@/components/commons/breadcrumb.vue";
import HeroSection from "@/components/setting-petcare/onboarding/hero-section.vue";
import MediaText from "@/components/setting-petcare/onboarding/media-text.vue";
import MarketingSpacer from "@/components/setting-petcare/onboarding/marketing-spacer.vue";

export default {
    mixins: [],
    components: {
        Breadcrumb,
        HeroSection,
        MediaText,
        MarketingSpacer
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: "Settings",
                    href: process.env.APPS + "business/business"
                },
                {
                    text: "PetCare"
                }
            ],
            mediaItems: [
                {
                    image:
                        "https://www.daysmart.com/vet/wp-content/uploads/sites/3/2023/11/Forms-2-1-971x1024.png",
                    title: "Simplify Appointment Management",
                    content:
                        "With the PetCare mobile app, your clients can easily request new appointments or confirm existing ones—saving your front desk team time that would otherwise be spent on manual client calls.",
                    reverse: false
                },
                {
                    image:
                        "https://www.daysmart.com/vet/wp-content/uploads/sites/3/2023/12/PetCare-2-971x1024.png",
                    title: "Provide Visibility Into Pet Health Data",
                    content:
                        "Allow clients to have a complete view of their pet's health at their fingertips—including medical records and vaccination certificates. Plus, they can also manage wellness plans in PetCare!",
                    reverse: true
                },
                {
                    image:
                        "https://www.daysmart.com/vet/wp-content/uploads/sites/3/2023/12/PetCare-3-971x1024.png",
                    title: "Improve Your Payment Process",
                    content:
                        "Easily send invoices or statements to clients and enable them to make online payments directly through their PetCare mobile app, ensuring a quick and seamless checkout experience.",
                    reverse: false
                }
            ]
        };
    }
};
</script>

<style scoped>
@import url("https://www.daysmart.com/vet/wp-includes/css/dist/block-library/style.min.css?ver=6.7.1");
@import url("https://www.daysmart.com/vet/wp-content/themes/daysmart/assets/fonts/fkdisplay/stylesheet.css?ver=1.2.1");
.page-content .media-text {
    margin-left: 18%;
    margin-right: 18%;
}
.h2,
h2 {
    color: #190d30;
    font-family: "FK Display", sans-serif;
    font-size: 32px;
    font-weight: 400;
    letter-spacing: -0.8px;
    line-height: 1.1;
    margin-bottom: 0px;
}

@media (min-width: 768px) {
    .h2,
    h2 {
        font-size: 32px;
    }
}

@media (min-width: 992px) {
    .h2,
    h2 {
        font-size: 32px;
    }
}

@media (min-width: 1200px) {
    .h2,
    h2 {
        font-size: 55px;
        letter-spacing: -1.5px;
        margin-bottom: 0px;
    }
}
</style>
